import React, { useState } from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import { CustomReactSelect, CustomButton, CustomModal, CustomCalendar } from '../../../shared';
import { CalendarIcon } from '../../../../assets';
import routeNames from '../../../../routes/routeNames';

const FilterBar = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [calendarOpen, setCalendarOpen] = useState(false);
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const dateRange = `${format(parseISO(startDateRange), 'MMM dd, yyyy')} -  ${format(parseISO(endDateRange), 'MMM dd, yyyy')}`;
    const {
        companyOptions, company,isOmaniChannel
    } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const { setCompany } = companyActions;
    const { triggerSummary: { totalTriggers,isTriggerSummaryGraphsLoading }, dtcData } = useSelector((state => state.trigger));
    const { isWebMatrixPatientLoading } = dtcData;
    const { dtcData: engagementRateData } = useSelector(state=>state.webMatrix);
    const { isEngagementRateLoading } = engagementRateData;
    const isDTCLoading = (isWebMatrixPatientLoading || isEngagementRateLoading || isTriggerSummaryGraphsLoading);
    const isHCPLoading = (isTriggerSummaryGraphsLoading);

    const handleNavigateToDashboard = () => {
        navigate(routeNames.DASHBOARD);
    };

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
        handleNavigateToDashboard();
    };

    const handleShowCalendar = () => {
        setCalendarOpen(!calendarOpen);
    };
    const showAudience = [66,61,64,161,165,94].includes(company.id) || isOmaniChannel;

    return (
        <Grid container className="flex-row-space-between mb-24px mt-10px">
            <Grid item xs={8}>
                <Box className="flex-row gap-12">
                    <Box className="w-50">
                        <CustomReactSelect
                            customStyle={{ borderRadius: '50px' }}
                            handleFilter={handleCompanyChange}
                            options={companyOptions}
                            placeholder="Select Company"
                            selectedOption={{ label: company.name, value: company.id }}
                        />
                    </Box>
                    {/* Select Inputs */}
                    <Box className="w-100">
                        <CustomButton
                            buttonColor="#FFFFFF"
                            handleClick={handleShowCalendar}
                            icon={<CalendarIcon />}
                            title={dateRange}
                            titleColor="#344054"
                        />
                        <CustomModal
                            component={<Box className="custom-modal-calendar-container">
                                <CustomCalendar closeModal={handleShowCalendar} />
                            </Box>}
                            handleClose={handleShowCalendar}
                            modalOpen={calendarOpen}
                            onClose={handleShowCalendar}
                        />
                    </Box>
                </Box>
            </Grid>
            <Grid item className="flex-row-justify-end gap-12" xs={4}>
                <Box className="flex-row-space-between bg-primary-50 br-16px gap-12 padding-10px height-40px">
                    <Box className="gap-8">
                        <Typography className="text-sm-medium gray-500">
                            {showAudience ?'Audience Count :' : 'Trigger Count :'}
                        </Typography>
                    </Box>
                    <Box>
                        {
                            (isOmaniChannel ? isDTCLoading : isHCPLoading) ? <Skeleton height={30} variant='text' width={40} /> :
                                <Typography className="text-sm-semi-bold gray-900">
                                    {totalTriggers}
                                </Typography>
                        }

                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

export default FilterBar;
